import { create } from 'zustand';

export interface CloudOverlayStoreType {
  visible: boolean;
  setVisible: (visible: boolean) => void;
}

export const useCloudOverlayStore = create<CloudOverlayStoreType>(set => ({
  visible: false,
  setVisible: visible => set({ visible }),
}));
